import { Link } from "react-router-dom";
import BookModel from "../../../models/BookModel";

export const SearchBook: React.FC<{ book: BookModel }> = (props) => {
  return (
    <div className="card mt-3 shadow p-3 mb-3 bg-body rounded">
      <div className="row g-0">
        <div className="col-md-2">
          {/* Desktop */}
          <div className="d-none d-lg-block">
            {props.book.img ? (
              <img src={props.book.img} width="123" height="196" alt="Books" />
            ) : (
              <img
                src={require("../../../Images/BooksImages/book-luv2code-1000.png")}
                width="123"
                height="196"
                alt="Books"
              />
            )}
          </div>
          {/* Mobile */}
          <div className="d-lg-none d-flex justify-content-center align-items-center">
            {props.book.img ? (
              <img src={props.book.img} width="123" height="196" alt="Books" />
            ) : (
              <img
                src={require("../../../Images/BooksImages/book-luv2code-1000.png")}
                width="123"
                height="196"
                alt="Books"
              />
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className="card-body">
            {props.book.author ? (
              <h5 className="card-title"> {props.book.author} </h5>
            ) : (
              "John Dow"
            )}
            <br />
            {props.book.title ? (
              <h4>{props.book.title}</h4>
            ) : (
              "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Assumenda porro neque explicabo alias minima id, totam commodi quam earum. Adipisci."
            )}

            <p className="card-text">{props.book.description}</p>
          </div>
        </div>
        <div className="col-md-4 d-flex justify-content-center align-items-center">
          <Link
            className="btn btn-md main-color text-white"
            to={`checkout/${props.book.id}`}
          >
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};
